<nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm border-bottom fixed-top">
  <div class="container px-5">

    <a class="navbar-brand d-flex align-items-center" routerLink="/transparencia/home">
      <div class="logo-box d-flex align-items-center justify-content-center">
        <b class="logo-text">TE</b>
      </div>
      <div class="logo-texto ms-2">
        <div class="titulo-principal">Transparência</div>
        <div class="titulo-secundario">Educacional</div>
      </div>
    </a>

    <div class="collapse navbar-collapse justify-content-center" id="menuNavegacao">
      <ul class="navbar-nav mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link px-3" routerLink="/transparencia/home" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">Início</a>
        </li>
        <li class="nav-item">
          <a class="nav-link px-3" routerLink="/transparencia/gestao-vagas-matriculas" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">Vagas</a>
        </li>
        <li class="nav-item">
          <a class="nav-link px-3" routerLink="/transparencia/bolsas-auxilios-convenios" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">Bolsas</a>
        </li>
        <li class="nav-item">
          <a class="nav-link px-3" routerLink="/transparencia/estatisticas-educacionais" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">Estatísticas</a>
        </li>
        <li class="nav-item">
          <a class="nav-link px-3" routerLink="/transparencia/execucao-orcamentaria" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">Orçamento</a>
        </li>
        <li class="nav-item">
          <a class="btn btn-area-adm ms-2" [attr.href]="domainService.getAdminUrl('/adm')"
            target="_blank"><i-lucide name="log-in" size="16" color="#0055A4"></i-lucide> Área administrativa</a>
        </li>
      </ul>
    </div>

    <button type="submit" class="btn-menu-hamburguer" (click)="toggleMenu()">
      <i class="fa-solid fa-bars"></i>
    </button>
  </div>
</nav>

<!-- Backdrop: aparece quando menuAberto == true -->
<div class="menu-backdrop" *ngIf="menuAberto" (click)="toggleMenu()"></div>

<!--Menu hamburguer-->
<div class="menu-hamburguer" [class.open]="menuAberto">
  <div class="menu-header">
    <div class="menu-title">
      <div class="menu-title-text">Mapa do Site</div>
    </div>
    <div class="menu-subtitle">
      <div class="menu-subtitle-text">Acesse todos os módulos do Portal de Transparência Educacional</div>
    </div>
  </div>

  <div class="only-mobile p-3">
    <a class="btn btn-area-adm-mobile" href="https://transparencia.educacao.homologacao.imap.org.br/adm"
      target="_blank">
      <i-lucide name="log-in" size="16" color="#fff"></i-lucide> Área administrativa
    </a>
  </div>

  <div class="menu-sections">
    @for (categoria of categorias; track $index) {
    <div class="menu-section">
      <div class="menu-section-title">
        <b class="menu-section-heading">{{ categoria.categoriaNome }}</b>
      </div>
      <div class="menu-items">
        @for(modulo of categoria.modulos; track $index){
        <a class="menu-item"  href="javascript:void(0)"  (click)="navegar(modulo); toggleMenu()" [class.menu-item-active]="isAtivo(modulo)">
          <div class="menu-item-icon">
            <i-lucide [name]="modulo.icone" size="26" color="#fff"></i-lucide>
          </div>
          <div class="menu-item-content">
            <div class="menu-item-title">
              <b>{{modulo.nome}}</b>
            </div>
            <div class="menu-item-description">
              {{modulo.descricao}}
            </div>
          </div>
          <span class="menu-item-badge" *ngIf="isAtivo(modulo)">Atual</span>
        </a>
        }
      </div>
    </div>
    }

    <!-- Seção Atendimento -->
    @if (cliente && cliente.clienteConfiguracao && cliente.clienteConfiguracao.ouvidoriaUrl) {
    <div class="menu-section">
      <div class="menu-section-title">
        <b class="menu-section-heading">Atendimento</b>
      </div>

      <a class="menu-item menu-item-full" [href]="cliente.clienteConfiguracao.ouvidoriaUrl" target="_blank"
        rel="noopener noreferrer" (click)="toggleMenu()">

        <div class="menu-item-icon">
          <i-lucide name="message-circle" size="26" color="#fff"></i-lucide>
        </div>

        <div class="menu-item-content">
          <div class="menu-item-title"><b>Ouvidoria</b></div>
          <div class="menu-item-description">
            Envie elogios, reclamações e denúncias
          </div>
        </div>
      </a>
    </div>
    }


    <div class="menu-footer">
      <div class="menu-footer-title">
        <b>Portal de Transparência Educacional</b>
      </div>
      <div class="menu-footer-subtitle">
        Acesso rápido a {{totalModulos}} módulos de informações públicas
      </div>
    </div>
  </div>

  <div class="menu-close-button" (click)="toggleMenu()" aria-label="Fechar menu">
    <i class="menu-close-icon fas fa-times"></i>
  </div>
</div>